<div class="audit-log-events">
  <div class="audit-log-events-above-header">
    <div class="audit-log-events-title">
      {{ 'userManagementPage.auditLogsPage.title' | labelsProvider }}
    </div>
  </div>

  <app-audit-log-events-filters [pageFilters]="pageFilters" />

  <div class="audit-log-events-header">
    @if (pageInfo().totalItems > -1) {
      <div class="audit-log-events-amount">{{ pageInfo().totalItems | number }} {{ 'events' }}</div>
    }
    <div class="audit-log-events-header-right">
      <app-columns-selection
        class="columns-selection"
        [pageName]="pageName"
        [columns]="columns()"
        (columnsSelected)="columnsSelected($event)"
      />
      <div class="export-button-container">
        <app-audit-log-events-export
          [disabled]="isLoading() || isEmptyTable()"
          [tooltipKey]="'common.inventoryExportToolTip'"
          (exportClick)="onExportClick()"
        />
      </div>
    </div>
  </div>

  <div class="audit-log-events-content">
    <app-audit-log-event-vertical-filters
      [pageFilters]="filtersModel"
      [isFiltersMenuOpen]="isFiltersMenuOpen()"
      (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
      (optionOnSelection)="tablesFiltersChange($event)"
      [ngClass]="{ 'filters-all': isFiltersMenuOpen() }"
    ></app-audit-log-event-vertical-filters>
    <app-prime-table
      #table
      [tabelWithIcon]="false"
      [withRowSelection]="false"
      [useBuiltInTextPopup]="false"
      queryParamProperty="auditLogEvent"
      [data$]="auditLogEventsCurrentPage$"
      [rowsPerPage]="defaultPageSize()"
      [columns]="columns()"
      [isLoading]="isLoading()"
      [withCheckboxSelection]="false"
      [withActions]="false"
      [sortedColumn$]="sortedColumn$"
      [pageInfo]="pageInfo()"
      tableNotFoundText="No audit log events found"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
      (pageOnChange)="onPageChange($event)"
      (textPopupClick)="onDetailsClick($event)"
      [ngClass]="
        !isFiltersMenuOpen() ? 'audit-log-events-content-collapsed-menu' : 'audit-log-events-content-component'
      "
    />
  </div>
</div>
